<h1 mat-dialog-title>{{ dialogTitle }}</h1>

<form #form="ngForm">
	<mat-dialog-content>
		<div class="flex-column mt-8">
			<mat-form-field subscriptSizing="dynamic" color="accent" class="w-100">
				<mat-label>Name</mat-label>
				<input matInput
					   [(ngModel)]="data.title"
					   name="name"
					   required
				/>
        @if (form.controls['name']?.errors?.required) {
          <mat-error>
            Name is required.
          </mat-error>
        }
			</mat-form-field>
			<mat-form-field subscriptSizing="dynamic" color="accent" class="w-100">
				<mat-label>Description</mat-label>
				<input matInput
					   [(ngModel)]="data.description"
					   name="description"
				/>
			</mat-form-field>

			<div class="flex-row align-items-stretch content-block">
        <app-markdown-editor
          [(ngModel)]="data.markdown"
          [ngModelOptions]="{standalone: true}"
          [height]="'400px'"
          [placeholder]="'Enter your text here...'"
          (markdownChange)="onContentChange($event)"
          class="w-100">
        </app-markdown-editor>
			</div>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions>
		<button mat-stroked-button mat-dialog-close>Cancel</button>
		<button mat-flat-button color="primary" [disabled]="form.invalid"
				(click)="handleActionButtonClick()">
			{{ dialogActionTitle }}
		</button>
	</mat-dialog-actions>
</form>
